// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SubmitNoticeOfIntentChangeRequestStep2Handler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NoticeOfIntentChangeRequestDTO from '../models/NoticeOfIntentChangeRequestDTO';
import ChangeRequestDTO from '../models/ChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    noticeOfIntentChangeRequest: NoticeOfIntentChangeRequestDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            noticeOfIntentChangeRequest: null,
        },
        initValues);
    },
    noticeOfIntentChangeRequest: 'noticeOfIntentChangeRequest',
}

interface Result extends ResultDTO {
    changeRequest: ChangeRequestDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequest: null,
        },
        initValues);
    },
    changeRequest: 'changeRequest',
}

export { Request, Result };